<template>
	<div class="mt-5">
		<h1 class="text-info">{{ notificationTitle }}</h1>
		<div v-if="notificationCount > 0" class="form-check text-start ms-4 text-info">
			<input class="form-check-input" type="checkbox" @click="markAllRead"/>
			<label class="form-check-label" for="flexCheckDefault"> Mark all as read </label>
		</div>
		<div
			v-show="post.group === 'Global'"
			v-for="post in getNotifications"
			:key="post"
			class="card bg-info text-start mb-3"
		>
			<div class="card-body">
				<h5 class="border-bottom">{{ post.byUser }} of {{ post.byUserLeague }} made a new post in global {{ posted(post.timeStamp)}}!</h5>
				<h6>{{ post.title }}</h6>
				<p>{{ post.message }}</p>
				<button class="btn btn-sm btn-outline-dark" @click="readNotification(post)">Mark as read</button>
			</div>
		</div>
		<div
			v-show="post.group === 'League'"
			v-for="post in getNotifications"
			:key="post"
			class="card bg-info text-start mb-3"
		>
			<div class="card-body">
				<h5 class="border-bottom">
					{{ post.byUser }} a {{ post.byUserType }} of the {{ post.byUserTeam }} posted in your league {{ posted(post.timeStamp)}}!
				</h5>
				<h6>{{ post.title }}</h6>
				<p>{{ post.message }}</p>
				<button class="btn btn-sm btn-outline-dark" @click="readNotification(post)">Mark as read</button>
			</div>
		</div>
		<div
			v-show="post.group === 'Team'"
			v-for="post in getNotifications"
			:key="post"
			class="card bg-info text-start mb-3"
		>
			<div class="card-body">
				<h4 class="border-bottom">{{ post.byUserType }} {{ post.byUser }} made a post to your team {{ posted(post.timeStamp)}}!</h4>
				<h5>{{ post.title }}</h5>
				<p>{{ post.message }}</p>
				<button class="btn btn-sm btn-outline-dark" @click="readNotification(post)">mark as read</button>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
moment().format();
export default {
	data() {
		return {
			
		};
	},
	computed: {
		notificationTitle() {
			if (this.notificationCount > 0) {
				return 'Notifications';
			} else {
				return 'No Notifications';
			}
		},
		notificationCount() {
			return this.$store.getters['notifications/getNotificationCount'];
		},
		getNotifications() {
			return this.$store.getters['notifications/getNotifications'];
		},
	},
	created() {
		this.loadNotifications();
	},
	watch: {
		getNotifications() {
			this.resetNotifications();
		},
	},
	methods: {
		markAllRead() {
			const userId = this.$store.getters.userId;
			const all = this.getNotifications
			const newPayload = []
			for(let i=0; i<all.length; i++) {
				all[i].viewedBy.push(userId)
				newPayload.push(all[i])
			}
			newPayload.forEach(i => this.readNotification(i, 1))
			this.loadNotifications();
		},
		async readNotification(post, num) {
			const userId = this.$store.getters.userId;
			const viewed = [...post.viewedBy];
			if(!num) {
				viewed.push(userId)
			}
			const payload = {
				postId: post.id,
				viewedBy: viewed,
				group: post.group,
			};
			try {
				await this.$store.dispatch('notifications/removeNotification', payload);
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
			this.loadNotifications();
		},
		resetNotifications() {
			if (this.getNotifications.length < 1) {
				this.$store.dispatch('notifications/resetNotifications');
			}
		},
		posted(timeStamp) {
			return moment(timeStamp).fromNow();
		},
		async loadNotifications() {
			try {
				await this.$store.dispatch('notifications/fetchNotifications');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
	},
};
</script>
